angular.module('ikeweb.spike', ['ikeweb.shared.notification', 'ikeweb.shared.promise'])
    .factory('SpikeUtil', ['$window',
        function($window) {

            function detectIE() {
                return ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName === 'Netscape') && (new RegExp('Trident/.*rv:([0-9]{1,}[\.0-9]{0,})|Edge/([0-9]{0,}[\.0-9]{0,})').exec(navigator.userAgent) != null)));
            }

            function sanitize(input, replacement) {
                var illegalRe = /[\/\?<>\\:\*\|":]/g;
                var controlRe = /[\x00-\x1f\x80-\x9f]/g;
                var reservedRe = /^\.+$/;
                var windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;

                var sanitized = input
                    .replace(illegalRe, replacement)
                    .replace(controlRe, replacement)
                    .replace(reservedRe, replacement)
                    .replace(windowsReservedRe, replacement);
                return sanitized;
            }

            function cleanFileName(input, options) {
                var replacement = (options && options.replacement) || '';
                var output = sanitize(input, replacement);
                if (replacement === '') {
                    return output;
                }
                return sanitize(output, '');
            }

            return {
                SVG: {
                    tag: function(tag) {
                        return document.createElementNS('http://www.w3.org/2000/svg', tag);
                    },
                    xlinkHref: function(el, url) {
                        return el.setAttributeNS('http://www.w3.org/1999/xlink', 'href', url);
                    }
                },
                parseSSLImageFix: function(url) {
                    return url.replace('http://', $window.location.protocol + '//' + $window.location.host + '/files/');
                },

                downloadBlob: function(blob, filename) {
                    if (detectIE()) {
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        var url = URL.createObjectURL(blob);
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.download = filename;
                        link.href = url;
                        link.click();
                        link.remove();
                    }
                },
                downloadURL: function(url, filename) {
                    var link = document.createElement('a');
                    if (filename != null) {
                        link.download = filename;
                    }
                    link.href = url;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                },
                cleanFileName: cleanFileName,
                /**
                 * [debounce rate limit a funciton call]
                 * @param  {[funciton]} func     [the function to rate limit]
                 * @param  {[number]} wait       [time between calls]
                 * @param  {[boolean]} immediate [run it now]
                 */
                debounce: function(func, wait, immediate) {
                    var timeout;
                    return function() {
                        var self = this,
                            args = arguments;
                        var later = function() {
                            timeout = null;
                            if (!immediate) {
                                func.apply(self, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(self, args);
                        }
                    };
                }
            };
        }
    ]);
angular.module('ikeweb.spike.capture', ['ikeweb.spike', 'ikeweb.shared.input', 'ikeweb.shared.notification',
    'ikeweb.shared.dialog', 'ikeweb.shared.decoration', 'ikeweb.shared.logging', 'ikeweb.shared.promise',
    'ikeweb.shared.caching', 'ikeweb.user', 'ikeweb.event', 'pascalprecht.translate'
]);

angular.module('ikeweb.spike.gallery', ['ikeweb.spike', 'ikeweb.shared.notification', 'ikeweb.shared.input',
    'ikeweb.shared.layout', 'ikeweb.shared.dialog', 'ikeweb.shared.printing', 'ikeweb.shared.logging',
    'ikeweb.shared.promise', 'ikeweb.spike.measure', 'ikeweb.spike.capture', 'ikeweb.unit', 'ikeweb.event',
    'ikeweb.layout', 'pascalprecht.translate', 'ikeweb.routes'
]);

angular.module('ikeweb.spike.measure', ['ikeweb.spike', 'ikeweb.shared.util', 'ikeweb.shared.input',
    'ikeweb.shared.layout', 'ikeweb.shared.messaging', 'ikeweb.unit', 'ikeweb.event', 'ikeweb.layout',
    'pascalprecht.translate', 'ikeweb.routes'
]);

angular.module('ikeweb.spike.report', ['ikeweb.spike', 'ikeweb.shared.input', 'ikeweb.shared.layout',
    'ikeweb.shared.printing', 'ikeweb.unit', 'ikeweb.spike.sharing', 'ikeweb.event', 'ikeweb.layout',
    'pascalprecht.translate', 'ikeweb.routes'
]);

angular.module('ikeweb.spike.sharing', ['ikeweb.spike', 'ikeweb.shared.notification', 'ikeweb.shared.input',
    'ikeweb.shared.layout', 'ikeweb.shared.dialog', 'ikeweb.shared.printing', 'ikeweb.shared.logging',
    'ikeweb.shared.promise', 'ikeweb.spike.measure', 'ikeweb.spike.capture', 'ikeweb.unit', 'ikeweb.event',
    'ikeweb.layout', 'pascalprecht.translate', 'ikeweb.routes'
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/spike.module.js
// module id = 412
// module chunks = 0